import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/brand-tokens.css'
import './styles/brand-utilities.css'
import { FavoritesProvider } from './context/FavoritesContext'
import { initSentry } from './lib/sentry'
import { initPerformanceMonitoring } from './lib/performance'

// Initialize error monitoring and performance tracking before React render
initSentry()
initPerformanceMonitoring()

createRoot(document.getElementById("root")!).render(
  <FavoritesProvider>
    <App />
  </FavoritesProvider>
);
